module.exports = __webpack_public_path__ + "img/slot.72d5807a.png";